<div id="popup-addcar-container">
    <mat-dialog-content [formGroup]="form">

        <p> ¿Como deseas pagar? </p>
        <mat-radio-group formControlName="type" aria-label="Select an option">
            <mat-radio-button value="Dinero">Dinero</mat-radio-button>
            <mat-radio-button value="Puntos">Puntos</mat-radio-button>
        </mat-radio-group>
    </mat-dialog-content>

    <mat-dialog-actions>

        <button class="mat-raised-button" (click)="save()">
      Ok
    </button>

        <button class="mat-raised-button" (click)="closeDialog()">
      Cabcelar
    </button>

    </mat-dialog-actions>
</div>